import {
	Component,
	OnInit,
	Output,
	EventEmitter,
	HostBinding,
	HostListener,
	Input,
	Inject,
	ElementRef,
	ViewChildren,
	QueryList,
	ViewChild,
	SimpleChanges,
} from "@angular/core";
import { PresentationModePopupModelService } from "./presentation-mode-popup-model.service";
import { CourseContextModelService } from "../../models/course-context-model.service";
import { CourseControllerService } from "../../controls/course-controller.service";
import { LanguageOption } from "app/core/vo/language-option";
import { AppServices } from "app/app.services";
import { UtilityScripts } from "../../../helpers/utility-scripts";
import { DescriptorModelService } from "../../models/descriptor-model.service";
import { Subscription } from "rxjs";
import { DOCUMENT } from "@angular/common";
import { ApplicationModel } from "app/core/models/application.model";
import { KeyPressConstants } from "app/core/vo/app-constants";
import { BaseView } from "../base-view";
@Component({
	selector: "app-presentation-mode-popup",
	templateUrl: "./presentation-mode-popup.component.html",
	styleUrls: ["./presentation-mode-popup.component.css"],
})
export class PresentationModePopupComponent extends BaseView implements OnInit {
	public hidePresentationPopup = false;
	public hideLanguageSelect = false;
	public hidePresentationMode = true;
	public strHeading = "";
	public strContinueLabel = "Continue";
	public textDirection = "";
	private descriptorSubscription: Subscription;
	public langLabel = "";
	public label = "";
	public sIndex: number = null;
	public index: number;
	public currentIndex = -1; 
	
	@Input() Languages: Array<LanguageOption>;
	@Output() presMode: EventEmitter<string> = new EventEmitter();
	@Output() languageUpdate: EventEmitter<string> = new EventEmitter();
	@Output() Closed: EventEmitter<string> = new EventEmitter();
	@ViewChildren("dropdownWithLang") langDropdown: QueryList<ElementRef>;
	@ViewChildren("radioWithMode") modeRadio: QueryList<ElementRef>;
	@ViewChild("dropdownBtn") dropdownBtn: ElementRef;

	@HostBinding("style.height") height: string;
	public constructor(
		private model: PresentationModePopupModelService,
		private descriptorService: DescriptorModelService,
		private CourseControllerService: CourseControllerService,
		private appService: AppServices,
		@Inject(DOCUMENT) private document: Document
	) {
		super();
		this.height = "100%";
		this.descriptorSubscription = this.descriptorService.notifier.subscribe(
			(data) => this.descriptorUpdate()
		);
	}

	ngOnInit() {
		// this.model.setLanguages(this.Languages);
		this.langLabel = this.Languages[0].langLabel;
		ApplicationModel.instance.isPresModeWindowOpen = true;	
	}
	public ngOnChanges(changes: SimpleChanges) {
		if (
			changes.hasOwnProperty("Languages") &&
			changes["Languages"]["currentValue"] !== undefined
		) {
			this.model.setLanguages(changes["Languages"]["currentValue"]);
			if (this.model.LanguagesLen === 1) {
				this.onLanguageSelected(this.model.languages[0], this.index);
				this.continue();
			}
			if (
				this.model.selectedLang !== "" &&
				this.model.presentationMode.length === 1
			) {
				this.model.setPresentationMode(this.model.presentationMode[0]);
				this.continue();
			}
		}
	}
	public onLanguageSelected(val, index) {
		this.sIndex = index;
		this.label = val.label;
		this.langLabel = val.langLabel;
		this.model.setLanguage(val);
		this.textDirection = val.direction;
		this.languageUpdate.emit(val);
		//this.CourseControllerService.updateStateSpecificContentmodel();
		this.model.enabledNext = this.model.selectedLang !== "" ? true : false;
		this.document.documentElement.lang = UtilityScripts.getLanguageCode(val.language);
		if (this.model.showDropdown === true) {
			this.model.showDropdown = false;
		}
		if(this.dropdownBtn) {
			this.dropdownBtn.nativeElement.focus();
		}
	}
	public showDropdownoption() {
		if (this.model.showDropdown === true) {
			this.model.showDropdown = false;
		} else {
			this.model.showDropdown = true;
		}
	}
	public accessDropdown(event, fromBtn: boolean){
		if(event.key === KeyPressConstants.ARROWDOWN || event.key === KeyPressConstants.ARROWUP){
		event.preventDefault();
	}
		this.navigateDropdown(event,  fromBtn, this.model.showDropdown, this.dropdownBtn, this.langDropdown, this.Languages, this.sIndex);
		this.model.showDropdown = this.getShowDropdown();
	}
	public onModeSelected(val) {
		this.model.setPresentationMode(val.mode);
		this.model.enabledNext = this.model.selectedPresMode !== "" ? true : false;
		this.presMode.emit(val.mode);
		this.appService.applicationStateChanged("ModeSelected");
	}

	public continue() {
		if (this.continue_label !== '') { /* To Be reviewed */
		if (
			this.model.selectedLang !== "" &&
			this.model.selectedPresMode === "" &&
			this.model.presentationMode &&
			this.model.presentationMode.length !== 1
		) {
			this.hideLanguageSelect = true;
			this.hidePresentationMode = false;
			setTimeout(() => {
				this.modeRadio.toArray()[0].nativeElement.focus();
			}, 300);
			this.model.enabledNext = false;
			this.strHeading = UtilityScripts.removeHTMLTags(
				this.descriptorService.getDescriptorTextById("presentationMode_str")
			);
		} else {
			ApplicationModel.instance.isPresModeWindowOpen = false;
			this.closePopup();
			setTimeout(() => {
				if(this.document.getElementById("geoLocSelectClosed")) {
					this.document.getElementById("geoLocSelectClosed").focus();
				}
			},300);
		}
		this.strContinueLabel = UtilityScripts.removeHTMLTags(
			this.descriptorService.getDescriptorTextById("continue_str")
		);
		}
	}

	private closePopup() {
		this.hidePresentationPopup = true;
		this.height = "0%";
		this.Closed.emit("popup_closed");
	}

	private descriptorUpdate() {
		if (this.descriptorSubscription) this.descriptorSubscription.unsubscribe();
		if (
			this.model.selectedLang !== "" &&
			this.model.selectedPresMode === "" &&
			this.model.presentationMode &&
			this.model.presentationMode.length !== 1
		) {
			this.strHeading = UtilityScripts.removeHTMLTags(
				this.descriptorService.getDescriptorTextById("presentationMode_str")
			);
		}
		this.strContinueLabel = UtilityScripts.removeHTMLTags(
			this.descriptorService.getDescriptorTextById("continue_str")
		);
	}
	public get continue_label(): string {
		return UtilityScripts.removeHTMLTags(
			this.descriptorService.getDescriptorTextById("continue_str")
		);
	}
	public onKeyClick(event){
		if ((event.shiftKey && event.code == KeyPressConstants.ARROWUP) || (event.ctrlKey && event.code == KeyPressConstants.ARROWUP)) {
			event.preventDefault();
		}
	}
}
